const utils = require('./utils');

const SMALL_BAG_ONLY = 'BO_SB';
const HAND_LUGGAGE = 'BO_HL';
const SPLITTER = ', ';

module.exports = {
    getCarriersWithSmallBagInCabin() {
        return (Odigeo.JCMS.carriersWithSmallBagInCabin || '')
            .split(SPLITTER)
            .reduce((acc, carrier) => carrier
                ? Object.assign(acc, {[carrier]: true})
                : acc
            , {});
    },

    getBoardingOptionsInfoFromBookingInfo(bookingInfo = {}) {
        const sections = [].concat(utils.getSections(bookingInfo) || []);
        const travellers = bookingInfo.travellers || [];
        const carriersWithSmallBagInCabin = this.getCarriersWithSmallBagInCabin();

        travellers.forEach((traveller) => {
            const travellerBoardingPreferences = traveller.boardingPreferences || [];
            sections.forEach((section) => {
                const boardingPreference = utils.findSelectedAncillaryBySection(section, travellerBoardingPreferences);
                const carrier = Odigeo._.get(section, 'carrier');
                const carrierProperties = Odigeo.JCMS.cabinBagsCarrierProperties[carrier] || {};
                const defaultBoardingType = carriersWithSmallBagInCabin[carrier]
                    ? SMALL_BAG_ONLY
                    : HAND_LUGGAGE;
                const boardingType = Odigeo._.get(boardingPreference, 'boardingType', defaultBoardingType);

                section.boardingType = section.boardingType || {};
                section.boardingType[boardingType] = section.boardingType[boardingType] ? section.boardingType[boardingType] + 1 : 1;
                section.cabinBagWeight = carrierProperties?.cabin_bag_weight || 0;
                section.priorityBoardingIncluded = carrierProperties?.priority_boarding_included || false;
            });
        });

        return sections;
    },
};
